import { apiClient } from './apiClient';

const call = async (method, path, options) => {
  const { data, error, response } = await apiClient[method](path, options);
  if (error) throw error;
  return { data, response };
};

export const authApi = {
  login: (body) => call('POST', '/api/v1/auth/login', { body }),
  signup: (body) => call('POST', '/api/v1/auth/signup', { body }),
  logout: () => call('POST', '/api/v1/auth/logout'),
  refresh: () => call('POST', '/api/v1/auth/refresh'),
  me: () => call('GET', '/api/v1/auth/me'),
  updateMe: (body) => call('PATCH', '/api/v1/auth/me', { body }),
  requestRegisterOtp: (mobile_phone) =>
      call('POST', '/api/v1/auth/register/request-otp', { body: { mobile_phone } }),
  verifyRegisterOtp: (mobile_phone, code) =>
      call('POST', '/api/v1/auth/register/verify-otp', { body: { mobile_phone, code } }),
  requestForgotPasswordOtp: (mobile_phone, national_id) =>
      call('POST', '/api/v1/auth/forgot-password/request-otp', {
        body: { mobile_phone, national_id },
      }),
  verifyForgotPasswordOtp: (mobile_phone, code) =>
      call('POST', '/api/v1/auth/forgot-password/verify-otp', { body: { mobile_phone, code } }),
  resetPassword: (verified_token, new_password) =>
      call('POST', '/api/v1/auth/reset-password', { body: { verified_token, new_password } }),
};

export const productsApi = {
  list: (query) => call('GET', '/api/v1/products', { params: { query } }),
  mine: (query) => call('GET', '/api/v1/products/my-products', { params: { query } }),
  get: (product_id) => call('GET', '/api/v1/products/{product_id}', { params: { path: { product_id } } }),
  create: (body) => call('POST', '/api/v1/products', { body }),
  update: (product_id, body) => call('PATCH', '/api/v1/products/{product_id}', { params: { path: { product_id } }, body }),
  remove: (product_id) => call('DELETE', '/api/v1/products/{product_id}', { params: { path: { product_id } } }),
  categories: (query) => call('GET', '/api/v1/products/categories', { params: { query } }),
  category: (category_id) => call('GET', '/api/v1/products/categories/{category_id}', { params: { path: { category_id } } }),
  createCategory: (body) => call('POST', '/api/v1/products/categories', { body }),
  removeCategory: (category_id) => call('DELETE', '/api/v1/products/categories/{category_id}', { params: { path: { category_id } } }),
  updateCategories: (product_id, body) => call('PATCH', '/api/v1/products/{product_id}/categories', { params: { path: { product_id } }, body }),
  uploadImage: (body) => call('POST', '/api/v1/products/upload-image', { body }),
};

// 👇 سبد خرید (Basket) به مسیر جدید customer/cart متصل شد
export const ordersApi = {
  addToBasket: (payload) => call('POST', '/api/v1/customer/cart/items/{product_id}', {
    params: {
      path: { product_id: payload.product_id },
      query: { quantity: payload.quantity }
    }
  }),
  getBasket: () => call('GET', '/api/v1/customer/cart'),
  updateBasketItem: (product_id, body) => call('PATCH', '/api/v1/customer/cart/items/{product_id}', { params: { path: { product_id } }, body }),
  removeBasketItem: (product_id) => call('DELETE', '/api/v1/customer/cart/items/{product_id}', { params: { path: { product_id } } }),
  clearBasket: () => call('DELETE', '/api/v1/customer/cart'),

  // بقیه موارد مربوط به سفارشات و پرداخت (بدون تغییر)
  quote: (body) => apiClient.POST('/api/v1/orders/quote', { body }),
  checkout: (body) => apiClient.POST('/api/v1/orders/checkout', { body }),
  mine: (query) => call('GET', '/api/v1/orders/my-orders', { params: { query } }),
  get: (order_id) => call('GET', '/api/v1/orders/{order_id}', { params: { path: { order_id } } }),
  paymentOptions: (order_id) => apiClient.GET('/api/v1/customer/orders/{order_id}/payment-options', { params: { path: { order_id } } }),
  cancel: (order_id) => call('POST', '/api/v1/orders/{order_id}/cancel', { params: { path: { order_id } } }),
  adminAll: (query) => call('GET', '/api/v1/super_admin/orders', { params: { query } }),
  adminUpdateStatus: (order_id, new_status) => call('PATCH', '/api/v1/super_admin/orders/{order_id}/status', { params: { path: { order_id }, query: { new_status } } }),
};

export const superAdminApi = {
  dashboard: () => call('GET', '/api/v1/super_admin/dashboard'),
  users: (query) => call('GET', '/api/v1/super_admin/users', { params: { query } }),
  updateUser: (user_id, body) => call('PATCH', '/api/v1/super_admin/users/{user_id}', { params: { path: { user_id } }, body }),
  deleteUser: (user_id) => call('DELETE', '/api/v1/super_admin/users/{user_id}', { params: { path: { user_id } } }),
  vendors: (query) => call('GET', '/api/v1/super_admin/vendors', { params: { query } }),
  verifyVendor: (vendor_id, body) => call('PATCH', '/api/v1/super_admin/vendors/{vendor_id}/verify', { params: { path: { vendor_id } }, body }),
  updateCommission: (vendor_id, body) => call('PATCH', '/api/v1/super_admin/vendors/{vendor_id}/commission', { params: { path: { vendor_id } }, body }),
  deleteVendor: (vendor_id) => call('DELETE', '/api/v1/super_admin/vendors/{vendor_id}', { params: { path: { vendor_id } } }),
  orders: (query) => call('GET', '/api/v1/super_admin/orders', { params: { query } }),
  updateOrderStatus: (order_id, new_status) => call('PATCH', '/api/v1/super_admin/orders/{order_id}/status', { params: { path: { order_id }, query: { new_status } } }),
};

export const locationsApi = {
  provinces: (query) => call('GET', '/api/v1/locations/provinces', { params: { query } }),
  province: (province_id) => call('GET', '/api/v1/locations/provinces/{province_id}', { params: { path: { province_id } } }),
  citiesByProvince: (province_id, query) => call('GET', '/api/v1/locations/provinces/{province_id}/cities', { params: { path: { province_id }, query } }),
  cities: (query) => call('GET', '/api/v1/locations/cities', { params: { query } }),
  get: (location_id) => call('GET', '/api/v1/locations/{location_id}', { params: { path: { location_id } } }),
  reverseGeocode: (lat, lng) =>
    call('GET', '/api/v1/locations/reverse-geocode', { params: { query: { lat, lng } } }),
};

export const vendorsApi = {
  list: (query) => call('GET', '/api/v1/vendors', { params: { query } }),
  get: (vendor_id) => call('GET', '/api/v1/vendors/{vendor_id}', { params: { path: { vendor_id } } }),
  getBySlug: (slug) => call('GET', '/api/v1/vendors/by-slug/{slug}', { params: { path: { slug } } }),
};

export const branchesApi = {
  list: (query) => call('GET', '/api/v1/branches', { params: { query } }),
  get: (admin_id) => call('GET', '/api/v1/branches/{admin_id}', { params: { path: { admin_id } } }),
};

export const referralPlansApi = {
  list: (query = { page: 1, size: 3 }) =>
    call('GET', '/api/v1/referral/plans', { params: { query } }),
};